import axios from "axios";
import { DataGrid, Popup } from "devextreme-react";
import { Column, Scrolling } from "devextreme-react/data-grid";
import CustomStore from "devextreme/data/custom_store";
import { useEffect, useState } from "react";

export default function ProjectCompletionDate(props) {
  const {
    projectCompletionDatePopupVisible,
    setProjectCompletionDatePopupVisible,
    contractBasicInfo,
  } = props;

  const [dataSource, setDataSource] = useState(null);

  useEffect(() => {
    setDataSource(
      new CustomStore({
        key: "id",
        load: async () => {
          // [R13]

          const result = await axios.get(
            `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/payt/paytStatus/projComplDate/${contractBasicInfo.contrNo}/${contractBasicInfo.SEQ}`
          );

          return result.data;
        },
      })
    );
  }, [contractBasicInfo.contrNo, contractBasicInfo.SEQ]);

  const onHiding = () => {
    setProjectCompletionDatePopupVisible(false);
  };

  const calculateCellValue = (data) => `${data.name} (${data.employeeNo})`;

  return (
    <Popup
      visible={projectCompletionDatePopupVisible}
      dragEnabled={false}
      hideOnOutsideClick={true}
      showCloseButton={true}
      showTitle={true}
      title="업무완료예정일 변경 이력"
      width={400}
      height={"auto"}
      onHiding={onHiding}
    >
      <DataGrid
        dataSource={dataSource}
        keyExpr={"id"}
        showBorders={true}
        allowColumnReordering={true}
        allowColumnResizing={true}
        rowAlternationEnabled={true}
        showRowLines={true}
        showColumnLines={true}
        // width={"100%"}
        // height={"100%"}
        style={{
          maxHeight: "calc(100vh - 145px)",
        }}
        columnAutoWidth={true}
        wordWrapEnabled={true}
      >
        <Scrolling
          mode={"virtual"}
          rowRenderingMode={"virtual"}
          columnRenderingMode={"virtual"}
          showScrollbar={"always"}
        />
        <Column
          dataField={"employeeNo"}
          caption={"Editor"}
          width={140}
          calculateCellValue={calculateCellValue}
        />
        <Column dataField={"date"} caption={"Edited Date"} width={100} />
        <Column
          dataField={"projComplDate"}
          caption={"업무완료예정일"}
          width={140}
        />
      </DataGrid>
    </Popup>
  );
}
